module.exports = __webpack_public_path__ + "img/icon-newsSwiper.abc5be30.png";